import React, { PropTypes, Component } from 'react';
import { Link } from 'react-router';

import Image from '../../../controls/image/Image.jsx';
import AuthInput from '../../../controls/authInput/AuthInput.jsx';
import ProgressBar from '../../../controls/progressBar/ProgressBar.jsx';

import { AUTH_IMAGES, IMAGE_LOGO_FULL } from 'pluton-core/lib/constants/image.constant';
import { history } from '../../../../entry/history';
import { routes } from 'pluton-core/lib/constants/routes.constant';


class ResetPasswordPage extends React.Component {

    componentDidUpdate(prevProps, prevState) {
        if (!prevProps.modelData.isAuth && this.props.modelData.isAuth) {
            history.replace(routes.home());
        }
    }

    handleSubmit = () => {
        const {
            error,
            modelForm,
            formData,
            handleOnValidate,
            handleSubmit,
            handleOnClearForm,
            handleClearError,
        } = this.props;

        const {
            modelData : {
                isNewPinRequested,
                pin: pinModel
            }
        } = this.props;
        formData.isNewPinRequested = isNewPinRequested;
        formData.pin = formData.pin || pinModel;

        const validation = modelForm.validate(formData, error);
        handleOnValidate(validation);
        if (!validation.isValid) {
            return;
        }

        handleSubmit(formData);
        // handleOnClearForm(formData);
        handleClearError();
    };

    handleOnChangeEmail = (event) => {
        const { handleOnChangeEmail } = this.props;
        handleOnChangeEmail(event.target.value.trim());
    };

    handleOnChangePassword = (event) => {
        const { handleOnChangePassword } = this.props;
        handleOnChangePassword(event.target.value.trim());
    };

    handleOnChangePasswordVerify = (event) => {
        const { handleOnChangePasswordVerify } = this.props;
        handleOnChangePasswordVerify(event.target.value.trim());
    };

    handleOnChangePin = (event) => {
        const { handleOnChangePin } = this.props;
        handleOnChangePin(event.target.value.trim());
    };

    handleOnKeyPressEmail = (event) => {
        if (event.charCode === 13) {
            const {
                modelData : {
                    isNewPinRequested,
                }
            } = this.props;

            if (isNewPinRequested) {
                this.refs.password.refs.input.focus();
            } else {
                this.handleSubmit();
            }
        }
    };

    handleOnKeyPressPassword = (event) => {
        if (event.charCode === 13) {
            this.refs.password2.refs.input.focus();
        }
    };

    handleOnKeyPressPassword2 = (event) => {
        if (event.charCode === 13) {
            this.refs.pin.refs.input.focus();
        }
    };

    handleOnKeyPressPin = (event) => {
        if (event.charCode === 13) {
            this.handleSubmit();
        }
    };

    renderProgressBar = () => {
        const { isLoading } = this.props;
        if (isLoading) {
            return (<ProgressBar/>)
        }

        return (null);
    };

    renderSendEmail = () => {
        const {
            error,
            modelForm,
            formData,
        } = this.props;

        const {
            isValid,
            email,
            emailError,
        } = formData;

        const {
            isValid: isValidRemote,
            emailError : emailErrorRemote,
            emailPlaceholder,
        } = modelForm.getPlaceholders(formData, error);

        return (
            <div className="form">
                <AuthInput ref="email"
                           placeholder={emailPlaceholder}
                           className={'field field--icon'}
                           iconUrl={ AUTH_IMAGES.ICON_MAIL }
                           type="email"
                           value={email}
                           onChange={this.handleOnChangeEmail}
                           onKeyPress={this.handleOnKeyPressEmail}/>
                {
                    (!isValid || !isValidRemote) &&
                    <div className="field-error">
                        {emailError || emailErrorRemote}
                    </div>
                }
            </div>
        )
    };

    renderResetPassword = () => {
        const {
            error,
            modelForm,
            formData,
            modelData
        } = this.props;

        const {
            isValid,
            email,
            emailError,
            password,
            passwordError,
            passwordVerify,
            passwordVerifyError,
            pin,
            pinError,
        } = formData;

        const {
            pin: pinModel
        } = modelData;

        const {
            isValid: isValidRemote,
            emailError : emailErrorRemote,
            emailPlaceholder,
            passwordPlaceholder,
            passwordVerifyPlaceholder,
            pinPlaceholder
        } = modelForm.getPlaceholders(formData, error);

        return (
            <div className="form">
                <AuthInput ref="email"
                           placeholder={emailPlaceholder}
                           className={'field field--icon'}
                           iconUrl={ AUTH_IMAGES.ICON_MAIL }
                           type="email"
                           value={email}
                           disabled={true}
                           onChange={this.handleOnChangeEmail}
                           onKeyPress={this.handleOnKeyPressEmail}/>
                {
                    (!isValid || !isValidRemote) &&
                    <div className="field-error">
                        {emailError || emailErrorRemote}
                    </div>
                }

                <AuthInput ref="password"
                           placeholder={passwordPlaceholder}
                           className={'field field--icon'}
                           iconUrl={ AUTH_IMAGES.ICON_PASSWORD }
                           type="password"
                           value={password}
                           onChange={this.handleOnChangePassword}
                           onKeyPress={this.handleOnKeyPressPassword}/>
                {
                    (!isValid || !isValidRemote) &&
                    <div className="field-error">
                        {passwordError}
                    </div>
                }

                <AuthInput ref="password2"
                           placeholder={passwordVerifyPlaceholder}
                           className={'field field--icon'}
                           iconUrl={ AUTH_IMAGES.ICON_PASSWORD }
                           type="password"
                           value={passwordVerify}
                           onChange={this.handleOnChangePasswordVerify}
                           onKeyPress={this.handleOnKeyPressPassword2}/>
                {
                    (!isValid || !isValidRemote) &&
                    <div className="field-error">
                        {passwordVerifyError}
                    </div>
                }

                <AuthInput ref="pin"
                           placeholder={pinPlaceholder}
                           className={'field field--icon'}
                           iconUrl={ AUTH_IMAGES.ICON_PIN }
                           type="number"
                           value={pin || pinModel}
                           onChange={this.handleOnChangePin}
                           onKeyPress={this.handleOnKeyPressPin}/>
                {
                    (!isValid || !isValidRemote) &&
                    <div className="field-error">
                        {pinError}
                    </div>
                }
            </div>
        )
    };

    renderBody() {
        const {
            modelData : {
                isNewPinRequested,
            }
        } = this.props;

        return (
            <div className="page__content page__content--entry">
                <div className="page__img page__img--entry">
                    <Link to={`${routes.login()}`}>
                        <Image src={IMAGE_LOGO_FULL}
                               className='logo-wrap'
                               imgClassName='logo logo--full'
                        />
                    </Link>
                </div>

                <h1 className="title title--entry">
                    Reset password
                </h1>

                {
                    isNewPinRequested ?
                        this.renderResetPassword() :
                        this.renderSendEmail()
                }
            </div>
        );
    }

    renderButton = () => {
        const {
            modelData : {
                isNewPinRequested,
            }
        } = this.props;

        const buttonText = isNewPinRequested ?
            "Change and Login" :
            "Next";

        return (
            <div className="btn-wrap">
                <Link onClick={this.handleSubmit} className="btn btn--prime">
                    {buttonText}
                </Link>
            </div>
        );
    };

    render() {
        return (
            <div className="app-container">
                <div className="page page--entry">
                    {this.renderBody()}
                    {this.renderProgressBar()}
                    {this.renderButton()}
                </div>
            </div>
        );
    }
}

ResetPasswordPage.PropTypes = {
    model: PropTypes.func,
    modelForm: PropTypes.func,
    modelData: PropTypes.object,
    formData: PropTypes.object,
    error: PropTypes.object,

    handleOnClearForm: PropTypes.func,
    handleOnValidate: PropTypes.func,
    handleSubmit: React.PropTypes.func,
    handleClearError: PropTypes.func,

    handleOnChangeEmail: PropTypes.func,
    handleOnChangeUsername: PropTypes.func,
    handleOnChangePassword: PropTypes.func,
    handleOnChangePasswordVerify: PropTypes.func
};

export default ResetPasswordPage;



// WEBPACK FOOTER //
// ./app/components/pages/auth/resetPassword/ResetPassword.page.jsx